import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'El Manual Maestro "El Efecto Sombra" (PDF)',
    desc: 'La guía completa con la psicología oscura de la atracción.'
  }, {
    title: 'El Protocolo de las 3 Fases',
    desc: 'Desvanecimiento, Vacío y Reaparición. Paso a paso.'
  }, {
    title: 'Guía de Mensajes "Interruptores"',
    desc: 'Frases Copy-Paste para WhatsApp que lo dejarán pensando en ti.'
  }, {
    title: 'El Método del "Espejo Roto"',
    desc: 'Técnica avanzada para recalibrar su interés en 24 horas.'
  }, {
    title: 'Checklist de Emergencia',
    desc: 'Qué hacer exactamente cuando sientas que vas a romper el silencio.'
  }];
  return <section className="py-20 bg-dark-100" data-id="element-227">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-228">
        <FadeIn data-id="element-229">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-white mb-16" data-id="element-230">
            Lo que obtienes <span className="text-gold-400 italic" data-id="element-231">hoy</span>
          </h2>
        </FadeIn>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-232">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={`bg-dark p-8 border border-gold-500/10 rounded-sm hover:border-gold-500/40 transition-all duration-300 group ${index === 0 ? 'md:col-span-2 lg:col-span-3 bg-gradient-to-br from-dark to-dark-100 border-gold-500/30' : ''}`} data-id="element-233">
              <div className="flex items-start gap-4" data-id="element-234">
                <CheckCircle2 className={`w-6 h-6 flex-shrink-0 mt-1 ${index === 0 ? 'text-gold-400' : 'text-gold-500/70 group-hover:text-gold-400'}`} data-id="element-235" />
                <div data-id="element-236">
                  <h3 className={`font-serif text-white mb-2 ${index === 0 ? 'text-2xl' : 'text-xl'}`} data-id="element-237">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-238">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}